export const replaceTemplateVariables = (text: string, cabmunId: number): string => {
  if (!text) return text;
  let decodedText = decodeURIComponent(text);
  decodedText = decodedText.replace(/\{\{\s*cabmun_id\s*\}\}/g, String(cabmunId || ''));
  return decodedText;
};

const convertMarkdownLinksToUrls = (text: string): string => {
  // Replace markdown links [text](url) → url only
  // Example: [https://site.com](https://site.com?utm_term=123) → https://site.com?utm_term=123
  return text.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, (_match, _label, url) => {
    return url;
  });
};

export const markdownPrepareTextCopy = (plainText: string, cabmunId: number) => {
  let result = replaceTemplateVariables(plainText, cabmunId);
  result = convertMarkdownLinksToUrls(result);
  return result;
};
